/** @file JS/TSで使う色名定義 */
/** Black */
export const BLACK: 'Black' = 'Black'

/** White */
export const WHITE: 'White' = 'White'

type GrayColor = 'Gray10' |'Gray25' | 'Gray50' | 'Gray100' | 'Gray200' | 'Gray400' | 'Gray600' | 'Gray700' | 'Gray900'
/** gray */
export const GRAY: readonly GrayColor[] = Object.freeze([
  'Gray10',
  'Gray25',
  'Gray50',
  'Gray100',
  'Gray200',
  'Gray400',
  'Gray600',
  'Gray700',
  'Gray900'
])

type BusinessColor = 'BusinessNavy50' | 'BusinessNavy100' | 'BusinessNavy200' | 'BusinessNavy300' | 'BusinessNavy400' | 'BusinessNavy500' | 'BusinessNavy600' | 'BusinessNavy700' | 'BusinessNavy800' | 'BusinessNavy900' | 'BusinessNavy1000'
/** Business */
export const BUSINESS: readonly BusinessColor[] = Object.freeze([
  'BusinessNavy50',
  'BusinessNavy100',
  'BusinessNavy200',
  'BusinessNavy300',
  'BusinessNavy400',
  'BusinessNavy500',
  'BusinessNavy600',
  'BusinessNavy700',
  'BusinessNavy800',
  'BusinessNavy900',
  'BusinessNavy1000',
])

type PrimaryColor = 'Primary' | 'Primary50' | 'Primary100' | 'Primary200' | 'Primary400' | 'Primary600' | 'Primary700' | 'Primary900'
/** Brand Color - Primary */
export const PRIMARY: readonly PrimaryColor[] = Object.freeze([
  'Primary',
  'Primary50',
  'Primary100',
  'Primary200',
  'Primary400',
  'Primary600',
  'Primary700',
  'Primary900',
])

type SecondaryColor = 'Secondary' | 'Secondary50' | 'Secondary75' | 'Secondary100' | 'Secondary300' | 'Secondary500' | 'Secondary700' | 'Secondary900'
/** Brand Color - Secondary */
export const SECONDARY: readonly SecondaryColor[] = Object.freeze([
  'Secondary',
  'Secondary50',
  'Secondary75',
  'Secondary100',
  'Secondary300',
  'Secondary500',
  'Secondary700',
  'Secondary900',
])

type AlertColor = 'Alert' | 'Alert100'
/** Interection Color - Alert */
export const ALERT: readonly AlertColor[] = Object.freeze([
  'Alert',
  'Alert100',
])

/** Interection Color - Star */
export const STAR: 'Star' = 'Star'

/** Interection Color - Pink */
export const PINK: 'Pink' = 'Pink'

/** Interection Color - Red */
export const RED: 'Red' = 'Red'

/** Interection Color - ORANGE */
type OrangeColor = 'Orange' | 'Orange50' | 'Orange700'
export const ORANGE: readonly OrangeColor[] = Object.freeze([
  'Orange',
  'Orange50',
  'Orange700'
])

type RankColor = 'Platinum' | 'Gold' | 'Silver' | 'Bronze'
/** Interection Color - Rank */
export const RANK: readonly RankColor[] = Object.freeze([
  'Platinum',
  'Gold',
  'Silver',
  'Bronze',
])

